module.exports = __webpack_public_path__ + "img/VideoIcon.1c396bab.svg";